import getFromAddress from '../utils/getFromAddress';
import type { AttachmentWellViewState } from 'owa-attachment-well-data';
import { getFullComposeViewState, getComposeEvent } from 'owa-calendar-compose-store-manager';
import getCurrentEventOrganizer from 'owa-calendar-compose-form-store/lib/selectors/getCurrentEventOrganizer';
import { lazyGetSharingTipRecipientInfo } from 'owa-link-data';
import type { SharingTipRecipientInfo } from 'owa-sharing-data';

export async function getRecipientInfosAndAttachmentWell(
    formId: string
): Promise<[SharingTipRecipientInfo[] | null, AttachmentWellViewState | null]> {
    const composeEvent = getComposeEvent(formId);
    const fullComposeViewState = getFullComposeViewState(formId);

    const organizer = getCurrentEventOrganizer(formId);
    const fromEmailAddress: string = getFromAddress(formId, organizer);

    // Only proceed if beautiful links are enabled, and we have attendees and a FullComposeViewState
    if (
        !composeEvent ||
        !fullComposeViewState ||
        !fullComposeViewState.attachmentWell ||
        !fromEmailAddress
    ) {
        return [null, null];
    }

    const recipientContainers = [composeEvent.RequiredAttendees, composeEvent.OptionalAttendees];
    const getSharingTipRecipientInfo = await lazyGetSharingTipRecipientInfo.import();
    const recipientInfos: SharingTipRecipientInfo[] = getSharingTipRecipientInfo(
        recipientContainers,
        fromEmailAddress
    );
    return [recipientInfos, fullComposeViewState.attachmentWell];
}
